import { ChangeDetectorRef, Component } from '@angular/core';
import { AProgessBarWizardComponent } from '../../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { ArrayHelpers } from '../../../helpers/array.helpers';
import { TranslateHelper } from '../../../helpers/injector.helper';

@Component({
    selector: 'siw-use-case-page',
    templateUrl: './siw.use.case.page.html',
    styleUrls: ['./siw.use.case.page.css']
})
export class SmartIntegrationWizardUseCasePage extends AProgessBarWizardComponent {
    AllSelected = true;
    Groups = [];
    UseCases = [];
    SearchText: string;

    get CanStepForward(): boolean {
        return this.WizardState.SelectedUseCase != null;
    }

    constructor(private cdRef: ChangeDetectorRef) {
        super();
    }

    OnWizardStateSet(): void {
        if (this.WizardState) {
            if (this.WizardState.UseCaseResult && this.WizardState.SelectedDataSource) {
                this.WizardState.UseCaseResult.some((x: any) => {
                    if (x.ExistingDataSources && x.ExistingDataSources.some((y: any) => y == this.WizardState.SelectedDataSource)) {
                        if (x.UseCases) {
                            const others = [];
                            x.UseCases.forEach((uc: any) => {
                                uc.Visible = true;
                                if (uc.Group) {
                                    let group = this.Groups.find((x: any) => x.Caption == uc.Group);
                                    if (group) {
                                        group.UseCases.push(uc);
                                    } else {
                                        this.Groups.push({
                                            Caption: uc.Group,
                                            Selected: false,
                                            Visible: true,
                                            UseCases: [uc]
                                        });
                                    }
                                } else {
                                    others.push(uc);
                                }
                            });
                            ArrayHelpers.sortAlphabetical(this.Groups, 'Caption');
                            if (others.length > 0) {
                                this.Groups.push({
                                    Caption: TranslateHelper.TranslatorInstance.instant('@@Andere'),
                                    Selected: false,
                                    Visible: true,
                                    UseCases: others
                                });
                            }
                            this.cdRef.detectChanges();
                        }
                        return true;
                    }
                    return false;
                });
            }
        }
    }

    SelectAll() {
        this.AllSelected = true;
        this.Groups.forEach(x => {
            x.Selected = false;
            x.Visible = x.UseCases.some((uc: any) => uc.Visible);
        });
        this.cdRef.detectChanges();
    }

    SelectGroup(group: any) {
        if (group.Selected) {
            group.Selected = false;
            if (this.Groups.some(x => x.Selected)) {
                group.Visible = false;
                this.AllSelected = false;
            } else {
                group.Visible = true;
                this.AllSelected = true;
                this.Groups.forEach(x => x.Visible = x.UseCases.some((uc: any) => uc.Visible));
            }
        } else {
            if (this.AllSelected) {
                this.Groups.forEach(x => x.Visible = false);
            }
            group.Selected = true;
            group.Visible = true;
            this.AllSelected = !this.Groups.some(x => !x.Selected);
        }
        this.cdRef.detectChanges();
    }

    onSearchChanged() {
        let toLower: string;
        if (this.SearchText) {
            toLower = this.SearchText.toLowerCase();
        }
        this.Groups.forEach((g: any) => {
            g.Visible = false;
            g.UseCases.forEach((uc: any) => {
                if (!toLower || uc.SearchText.includes(toLower)) {
                    uc.Visible = true;
                    g.Visible = this.AllSelected || g.Selected;
                } else {
                    uc.Visible = false;
                }
            });
        });
        this.cdRef.detectChanges();
    }

    onUseCaseSelected(useCase: any) {
        this.WizardState.SelectedUseCase = useCase;
    }
}
